module.exports = __webpack_public_path__ + "media/virusColectivo.c1fe988c.mp4";